const themes = ["dark", "light"];

export default themes;
